<div class="message-main" [hidden]="removed">
  <div class="message-remove">
    <core-helpers-navigation-three-dots-menu *ngIf="delete" [menu]="menu" (action)="onMenuClick($event,message)"></core-helpers-navigation-three-dots-menu>
  </div>
    <core-message-body
        [message]="message"
        [feedback]="feedback"
        [versionShares]="versionShares"
    > </core-message-body>
    <ng-container [ngSwitch]="message.type">
      <!-- type 'text': default old text message -->
      <ng-template [ngSwitchCase]="'text'">
        <core-message-files
            *ngIf="context == 'message-default' || (context != 'message-default' && prefixUrl != '')"
            [message]="message"
            [prefixUrl]="prefixUrl"
            [context]="context"
            [notesActionText]="notesActionText"
            [notesActionStyle]="notesActionStyle"
            [canCreateNotes]="canCreateNotes"
        ></core-message-files>
      </ng-template>
      <!-- type 'video': new video message -->
      <ng-template [ngSwitchCase]="'video'">
        <core-message-video
            [message]="message"
            [context]="context"
        ></core-message-video>
      </ng-template>
      <ng-template [ngSwitchCaseDefault]>
        <core-message-files
            *ngIf="context == 'message-default' || (context != 'message-default' && prefixUrl != '')"
            [message]="message"
            [prefixUrl]="prefixUrl"
            [context]="context"
            [notesActionText]="notesActionText"
            [notesActionStyle]="notesActionStyle"
            [canCreateNotes]="canCreateNotes"
        ></core-message-files>
      </ng-template>
    </ng-container>
    
</div>
<core-helpers-box-loading [hidden]="!working"></core-helpers-box-loading>
<core-helpers-box-success [hidden]="!success"></core-helpers-box-success>
<div [hidden]="!error" class="alert-warning">
  <core-helpers-box-alert-message-icon
      [text]="'There was an error removing your message.'"
      [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
  <div class="fieldset">
    <core-helpers-forms-button-icon
        [text]="'Ok'"
        [icon]="''"
        (click)="try()"
    ></core-helpers-forms-button-icon>
  </div>
</div>
